module.exports = __webpack_public_path__ + "static/img/01.97b0996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/01/01.jpg
// module id = lgXa
// module chunks = 1